(() => {
  if (customElements.get('sakumo-order-preparation')) return;

  const state = { selected: null, queue: Promise.resolve(), pending: 0 };
  const instances = () => document.querySelectorAll('sakumo-order-preparation');
  const update = (message = '') => instances().forEach((element) => {
    element.querySelector('[data-video-option]').checked = state.selected;
    const summary = element.querySelector('[data-video-summary]');
    if (summary) summary.textContent = state.selected ? summary.dataset.selected : summary.dataset.optional;
    element.querySelector('[data-preparation-value]').value = state.selected ? 'Vidéo' : 'Classique';
    element.querySelector('[data-video-consent]').value = state.selected ? 'Oui' : 'Non';
    element.querySelector('[data-preparation-status]').textContent = message;
  });

  function save() {
    const selected = state.selected;
    state.pending += 1;
    update('Enregistrement…');
    state.queue = state.queue.catch(() => {}).then(async () => {
      const response = await fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: {
          'Préparation': selected ? 'Vidéo' : 'Classique',
          'Autorisation vidéo': selected ? 'Oui' : 'Non'
        } })
      });
      if (!response.ok) throw new Error('Cart preference could not be saved');
      const cart = await response.json();
      if (cart.attributes?.['Autorisation vidéo'] !== (selected ? 'Oui' : 'Non')) {
        throw new Error('Cart preference was not saved');
      }
    }).then(() => {
      state.pending -= 1;
      if (!state.pending) update('Choix enregistré.');
    }, () => {
      state.pending -= 1;
      if (!state.pending) update('Le choix sera enregistré lors du passage au paiement avec le bouton ci-dessous.');
    });
  }

  class OrderPreparation extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const initial = state.selected === null;
      if (initial) state.selected = this.dataset.videoSelected === 'true';
      const checkbox = this.querySelector('[data-video-option]');
      checkbox.disabled = false;
      checkbox.addEventListener('change', () => {
        state.selected = checkbox.checked;
        save();
      });
      update();
      // Old Live/Video selections did not include the new publication agreement.
      if (initial && this.dataset.previousPreparation &&
          this.dataset.previousPreparation !== (state.selected ? 'Vidéo' : 'Classique')) save();
    }
  }
  customElements.define('sakumo-order-preparation', OrderPreparation);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!state.pending || !(form instanceof HTMLFormElement) ||
        !['cart', 'CartDrawer-Form'].includes(form.id)) return;
    event.preventDefault();
    const submitter = event.submitter;
    const finish = () => {
      // A new selection may have queued another save while checkout was waiting.
      if (state.pending) return state.queue.then(finish);
      if (!form.isConnected) return;
      update();
      if (submitter?.isConnected && submitter.form === form) form.requestSubmit(submitter);
      else form.requestSubmit();
    };
    state.queue.then(finish);
  }, true);
})();
